// extracted by mini-css-extract-plugin
export default {"stickyBtnWrap":"Style_stickyBtnWrap__F0-9h","upperWrap":"Style_upperWrap__DqR9Q","upperNum":"Style_upperNum__a1Koo","btnWrap":"Style_btnWrap__6-5Zt","edit":"Style_edit__DnefL"};